import {
	GET_PREFIXES_REQUEST,
	GET_PREFIXES_SUCCESS,
	GET_PREFIXES_ERROR,
	GET_PREFIX_REQUEST,
	GET_PREFIX_SUCCESS,
	GET_PREFIX_ERROR,
	CREATE_PREFIX_REQUEST,
	CREATE_PREFIX_SUCCESS,
	CREATE_PREFIX_ERROR,
	EDIT_PREFIX_REQUEST,
	EDIT_PREFIX_SUCCESS,
	EDIT_PREFIX_ERROR,
	DELETE_PREFIX_REQUEST,
	DELETE_PREFIX_SUCCESS,
	DELETE_PREFIX_ERROR
} from "@/actions"

import {
	prefixService
} from "@/services"

import { addNewFilter, isEmpty, decodeLaravelValidationErrors } from "@/utilities"

const state = {
	prefixes: [],
	prefix: {},
	loading: false
}

const getters = {
	prefixes: state => state.prefixes,

	prefixSelectOptions: state => {
		return state.prefixes?.filter(p => p?.deleted_at == null)?.sort((a, b) => a?.sort - b?.sort)?.map((prefix) => {
			return { label: prefix.label, value: prefix.uuid, }
		});
	},

	prefixByUuid: state => uuid => state.prefixes.find(p => p.uuid == uuid)
}

const actions = {
	async getPrefixes({ commit }) {
		commit("GET_PREFIXES_REQUEST")
		const response = await prefixService.getPrefixes();
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_PREFIXES_SUCCESS", data)
				break
			default:
				commit("GET_PREFIXES_ERROR")
		}
		return response
	},
	async getPrefix({ commit }, params) {
		commit("GET_PREFIX_REQUEST")
		const response = await prefixService.getPrefix(params)
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_PREFIX_SUCCESS", data)
				break
			default:
				commit("GET_PREFIX_ERROR")
				break
		}
		return response
	},
	async createPrefix({ commit, dispatch }, params) {
		commit("CREATE_PREFIX_REQUEST")
		const response = await prefixService.createPrefix(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data?.success) {
					commit("CREATE_PREFIX_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Prefix created.", { root: true })
				}

				if(data?.error) {
					commit("CREATE_PREFIX_ERROR", data)
					dispatch("alert/createAlertErrors", data?.errors ? decodeLaravelValidationErrors(data.errors) : "Oops. Something went wrong. Prefix not created.", { root: true })
				}
				break
			default:
				commit("CREATE_PREFIX_ERROR")
		}
		return response
	},
	async editPrefix({ commit, dispatch }, params) {
		commit("EDIT_PREFIX_REQUEST")
		const response = await prefixService.editPrefix(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if(data?.success) {
					commit("EDIT_PREFIX_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Prefix updated.", { root: true })
				}

				if(data?.error) {
					commit("EDIT_PREFIX_ERROR", data)
					dispatch("alert/createAlertErrors", data?.errors ? decodeLaravelValidationErrors(data.errors) : "Oops. Something went wrong. Prefix not updated.", { root: true })
				}
				
				break
			default:
				commit("EDIT_PREFIX_ERROR")
		}
		return response
	},
	async deletePrefix({ commit, dispatch }, uuid) {
		commit("DELETE_PREFIX_REQUEST")
		const response = await prefixService.deletePrefix(uuid)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					const { prefix } = data
					commit("DELETE_PREFIX_SUCCESS", { ...prefix, uuid })
					dispatch("alert/createAlertSuccess", "Prefix deleted.", { root: true })
				}

				if (data?.error) {
					commit("DELETE_PREFIX_ERROR")
					dispatch("alert/createAlertErrors", data?.errors ? decodeLaravelValidationErrors(data.errors) : "Oops. Something went wrong. Prefix not deleted.", { root: true })	
				}

				break
			default:
				commit("DELETE_PREFIX_ERROR");
		}
		return response
	},

	async reorderPrefixes({ commit, dispatch }, params) {
		return await prefixService.reorderPrefixes(params)
	},

	async updateSortOrder({ commit, dispatch }, params) {
		commit("UPDATE_SORT_ORDER", params)
	}
}

const mutations = {
	[GET_PREFIXES_REQUEST]: state => {
		state.loading = true
	},
	[GET_PREFIXES_SUCCESS]: (state, data) => {
		const prefixes = [...data.prefixes]
		state.prefixes = prefixes
		state.loading = false
	},
	[GET_PREFIXES_ERROR]: state => {
		state.loading = false
		state.error = true
	},
	[GET_PREFIX_REQUEST]: state => {
		state.loading = true
	},
	[GET_PREFIX_SUCCESS]: (state, data) => {
		const { prefix } = data;
		state.prefixes = addNewFilter(state.prefixes, [prefix])
		state.loading = false
	},
	[GET_PREFIX_ERROR]: (state, data) => {
		state.loading = false
	},
	[CREATE_PREFIX_REQUEST]: state => {
		state.loading = true
	},
	[CREATE_PREFIX_SUCCESS]: (state, data) => {
		const { prefix } = data;
		state.prefixes = addNewFilter(state.prefixes, [prefix])
		state.loading = false
	},
	[CREATE_PREFIX_ERROR]: state => {
		state.loading = false
	},
	[EDIT_PREFIX_REQUEST]: state => {
		state.loading = true
	},
	[EDIT_PREFIX_SUCCESS]: (state, data) => {
		const { prefix } = data
		state.prefixes = addNewFilter(state.prefixes, [prefix])
		state.loading = false
	},
	[EDIT_PREFIX_ERROR]: state => {
		state.loading = false
	},
	[DELETE_PREFIX_REQUEST]: state => {
		state.loading = true
	},
	[DELETE_PREFIX_SUCCESS]: (state, prefix) => {
		const { deleted_at, uuid } = prefix;
		if (!isEmpty(deleted_at)) {
			state.prefixes = addNewFilter(state.prefixes, [prefix])	
		} else {
			state.prefixes = state.prefixes.filter((prefix) => prefix.uuid != uuid)
		}

		state.loading = false
	},
	[DELETE_PREFIX_ERROR]: (state) => {
		state.loading = false
	},
	UPDATE_SORT_ORDER: (state, params) => {
		state.prefixes = state.prefixes.map((prefix) => {

			if (prefix?.uuid == params?.uuid) {
				prefix.sort = params?.sort
			}

			return prefix
		});
	}
}

export const prefix = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}